import get from 'lodash/get';
import type * as Types from './types';

export const Invite = (item?: any): Types.IEntity.Invite => ({
  id: get(item, 'id') || '',
  testId: get(item, 'test_id') || '',
  testTitle: get(item, 'test_title') || '',
  email: get(item, 'email') || '',
  code: get(item, 'code') || '',
  status: get(item, 'status') || 'pending',
  expiresAt: get(item, 'expires_at') ? new Date(get(item, 'expires_at')) : new Date(),
  createdAt: get(item, 'created_at') ? new Date(get(item, 'created_at')) : new Date(),
  acceptedAt: get(item, 'accepted_at') ? new Date(get(item, 'accepted_at')) : undefined,
});

export const Meta = (item?: any): Types.IEntity.Meta => ({
  total: get(item, 'total') || 0,
  page: get(item, 'page') || 1,
  perPage: get(item, 'per_page') || 10,
  totalPages: get(item, 'total_pages') || 0,
});
